import React from "react";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { initializeApp } from "firebase/app";
import { setLoader, unsetLoader } from "../../common/loader/action.js";
import { set_snack_bar } from "../../common/snackbar/action.js";
import * as CONSTANT from "./constant.js";
import UNIVERSAL from "../../config/config.js";

// Initialize Firebase directly on the page
const firebaseConfig = {
  apiKey: "AIzaSyA3ZPq_0WoGSG4ojivHDV6EcmC28RpJfnA",
  authDomain: "qrcode-93aa5.firebaseapp.com",
  projectId: "qrcode-93aa5",
  storageBucket: "qrcode-93aa5.appspot.com",
  messagingSenderId: "840472327459",
  appId: "1:840472327459:web:80c7bdbbbb4658be9a0896",
  measurementId: "G-CVK0BS4YHE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export function login(email, password) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson);
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch({ type: CONSTANT.LOGIN, payload: responseJson.data.result });
          dispatch(setAdminLogin(responseJson));
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}
export function UserRegister(name, email, mobile, access) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/register", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        mobile,
        access,
        name,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson);

        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
          // dispatch(onLogout());
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}

export function setAdminLogin(payload) {
  payload.data.result.token = payload.data.token;
  localStorage.setItem("token", payload.data.token);
  return {
    type: CONSTANT.LOGIN,
    token: payload.data.token,
    payload: payload.data.result,
  };
}
export function setTokenData(payload) {
  payload.user_id.token = payload.token;
  localStorage.setItem("token", payload.token);
  return {
    type: CONSTANT.LOGIN,
    payload: payload.user_id,
  };
}

export function updateProfile(token, user_id, name, oldpassword, password) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/changepassword", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        user_id,
        name,
        password: oldpassword,
        newpassword: password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson);

        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch(onLogout());
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
          // dispatch(onLogout());
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}

export function updateProfilePic(token, user_id, profilepic) {
  return (dispatch) => {
    dispatch(setLoader(true));
    if (profilepic !== "") {
      const storageRef = ref(
        getStorage(),
        "/profile/" + profilepic + Math.random() + ".png"
      );
      const uploadimage = uploadBytesResumable(storageRef, profilepic);
      uploadimage.on(
        "state_changed",
        function (snapshot) {},
        function (error) {
          console.log(error);
          //   dispatch(setalert(true, "Image Could Not Be Uploaded"));
          dispatch(setLoader(false));
        },

        function () {
          getDownloadURL(uploadimage.snapshot.ref).then(function (profilepic) {
            if (getDownloadURL(uploadimage.snapshot.ref) !== null) {
              dispatch(updateProfilePics(token, user_id, profilepic));
              dispatch(set_snack_bar(true, "Image Uploaded"));
            } else {
              dispatch(set_snack_bar(true, "Image not Uploaded"));
            }
          });
        }
      );
    } else {
      dispatch(updateProfilePics(token, user_id, profilepic));
    }
  };
}

export function updateProfilePics(token, user_id, profilepic) {
  console.log("5555555555555555555555555", token, user_id, profilepic);

  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/updateProfile", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        user_id,
        profile_pic: profilepic,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson);
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch(setProfilePic(responseJson.data.profile_pic));
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
          // dispatch(onLogout());
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}

export function setProfilePic(payload) {
  console.log(payload);

  return {
    type: CONSTANT.PROFILEPIC,
    payload: payload,
  };
}
export function onLogout() {
  localStorage.removeItem("token");

  return {
    type: CONSTANT.LOGOUT,
  };
}

export function fetchToken(token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/getUserToken", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(setTokenData(responseJson.data));
          dispatch(unsetLoader());
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403 ||
          responseJson.statusCode === 409
        ) {
          dispatch(onLogout());
          dispatch(unsetLoader());
        } else {
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}

export function forgotpassword(email) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/forgotpassword", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch({
            type: CONSTANT.PASSWORD_GENERATE,
            payload: responseJson.message,
          });
          dispatch(unsetLoader());
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {
          dispatch(onLogout());
          dispatch(unsetLoader());
        } else {
          dispatch({
            type: CONSTANT.PASSWORD_GENERATE,
            payload: responseJson.message,
          });
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}
export function setGoogleLoginData(payload, token) {
  console.log(payload, token);
  return {
    token: token,
    type: CONSTANT.LOGIN,
    payload: payload,
  };
}